import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../i18n/LanguageContext';
import './CTASection.css';

const CTASection = () => {
  const { t } = useLanguage();

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <section className="cta-section">
      <p>{t('cta.body')}</p>
      <Link className="cta-button" to="/object-form?workflow=slim" onClick={handleClick}>
        <FontAwesomeIcon icon={faPlusCircle} />
        <span>&nbsp;&nbsp; {t('common.createAd')}</span>
      </Link> <br/>

      <Link className="cta-button" to="/faq" onClick={handleClick}>
        <FontAwesomeIcon icon={faQuestionCircle} />
        <span>&nbsp;&nbsp;{t('common.faq')}</span>
      </Link>
    </section>
  );
};

export default CTASection;
